import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { Fetch } from "../../shared/Fetch";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface ICompanyList {
    id?: number,
    company_ID?: number,
    company_Name?: string,
    send_Email?: boolean,
    updated_By?: number,
    updated_On?: Date,
}

export const CompanyTable = (toast: any) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ICompanyList[], loading: boolean });
    const dt = useRef<any>(null);

    const header = () => {
        return <p>Timesheet Email Sending Setting Company Wise</p>;
    }

    const toggleStatus = async (id: number) => {
        const response = await Fetch(`Timesheet/updateSendEmailCompany`, "PUT", null, `id=${id}`, toast);
        if (response) {
            loadTableData();
        }
    }

    const updatedOn = (rowData: any) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy HH:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const response = await Fetch(`Timesheet/getCompanyList`, "GET", null, null, toast);
        if (response) {
            const data: Array<ICompanyList> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    useEffect(() => {
        loadTableData();
    }, []);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", height: "60vh" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="65vh"
                value={tableData.tableData} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="company_Name" header="Company Name" />
                <Column field="send_Email" header="Send Email" body={(rowData: any) => <p onClick={() => toggleStatus(rowData.id)} style={{ color: (rowData.send_Email === true) ? "green" : "red" }} className="cursor-pointer">{rowData.send_Email === true ? "Yes" : "No"}</p>} />
                <Column field="updated_By" header="Updated By" />
                {/* <Column field="updated_On" header="Updated On" body={updatedOn} /> */}
                <Column header="Updated On" sortable body={(rowData: any) => safeFormatDate(rowData.updated_On, "dd/MM/yyyy",  DateFormat, true)}/>
            </DataTable>
        </>
    );
}